



















import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import moment from "moment";
import UserStore from "../stores/UserStore";

@Component
export default class MessageItem extends Vue {

  @Prop()
  source: any;
  @Prop()
  onClick: ((id: number, event: MouseEvent) => void) | undefined;
  @Inject()
  // @ts-ignore
  private userStore: UserStore;

  get date(): string {
    if (!this.source.sent_at) {
      return moment(this.source.modified_at).format('L LT');
    }
    return moment(this.source.sent_at).format('L LT');
  }

  get emailIcon(): Array<string> {
    if (this.hasSeen) {
      return ['far', 'envelope-open']
    }
    return ['fas', 'envelope']
  }

  get hasSeen(): boolean {
    return this.userStore.hasSeenMessage(this.source);
  }

  public click(event: MouseEvent) {
    if (this.onClick) {
      this.onClick(this.source.id, event);
    }
  }
}
